import React, { useState } from 'react';
import { ChevronDown, Check } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function KitContents() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const tomos = [{
    title: 'TOMO 1 — GESTIÓN DE ESTABLECIMIENTOS RURALES',
    icon: '🌾',
    items: ['Organización del campo', 'Recursos productivos', 'Planificación del establecimiento', 'Gestión operativa', 'Evaluación productiva'],
    highlight: 'Para enseñar cómo funciona el campo real'
  }, {
    title: 'TOMO 2 — ADMINISTRACIÓN AGROPECUARIA',
    icon: '🌾',
    items: ['Costos de producción', 'Rentabilidad', 'Margen bruto', 'Planificación económica', 'Comercialización'],
    highlight: 'Para que tus alumnos entiendan el negocio agro'
  }, {
    title: 'TOMO 3 — LEGISLACIÓN AGRARIA',
    icon: '🌾',
    items: ['Marco legal argentino', 'Derechos y obligaciones', 'Propiedad rural', 'Normativa vigente', 'Resolución de conflictos'],
    highlight: 'Para enseñar leyes sin complicarte'
  }, {
    title: 'TOMO 4 — CONTRATOS RURALES',
    icon: '🌾',
    items: ['Arrendamiento', 'Aparcería', 'Contratos reales', 'Interpretación legal', 'Redacción básica'],
    highlight: 'Para llevar lo legal a lo práctico'
  }, {
    title: 'TOMO 5 — NORMATIVA AMBIENTAL',
    icon: '🌾',
    items: ['Uso del suelo', 'Impacto ambiental', 'Legislación ambiental', 'Sustentabilidad', 'Casos reales'],
    highlight: 'Para enseñar agro con conciencia actual'
  }, {
    title: 'TOMO 6 — SEGURIDAD E HIGIENE RURAL',
    icon: '🌾',
    items: ['Riesgos laborales', 'Protocolos', 'Uso de maquinaria', 'Normativas', 'Prevención'],
    highlight: 'Para enseñar con responsabilidad profesional'
  }];
  return <section className="bg-[#F5F6F7] py-3 md:py-4 px-3 border-b border-gray-200" data-id="element-86">
      <div className="max-w-2xl mx-auto" data-id="element-87">
        <h2 className="text-xl md:text-2xl font-black text-[#1F3D2B] text-center mb-0.5 uppercase tracking-tight" data-id="element-88">
          📖 QUÉ RECIBÍS
        </h2>
        <p className="text-[#D4A843] text-center text-xs font-black mb-2 tracking-widest" data-id="element-89">
          (CON ÍNDICE REAL)
        </p>

        <div className="space-y-1 mb-2" data-id="element-90">
          {tomos.map((tomo, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-91">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-center justify-between p-2 text-left hover:bg-gray-50 transition-colors" data-id="element-92">
                  <span className="font-black text-[#1F3D2B] text-xs md:text-sm flex items-center gap-2" data-id="element-93">
                    <span className="text-base" data-id="element-94">{tomo.icon}</span> {tomo.title}
                  </span>
                  <motion.div animate={{
                rotate: isOpen ? 180 : 0
              }} data-id="element-95">
                    <ChevronDown className="w-4 h-4 text-[#2E5A3E]" data-id="element-96" />
                  </motion.div>
                </button>
                <AnimatePresence data-id="element-97">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} className="overflow-hidden" data-id="element-98">
                      <div className="px-2 pb-2 border-t border-gray-100 bg-white" data-id="element-99">
                        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-1 mt-1 mb-1" data-id="element-100">
                          {tomo.items.map((item, i) => <li key={i} className="flex items-start gap-1 text-gray-700 font-bold text-[10px] md:text-xs" data-id="element-101">
                              <Check className="w-3 h-3 text-[#D4A843] flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-102" />
                              <span data-id="element-103">{item}</span>
                            </li>)}
                        </ul>
                        <div className="bg-[#F5F0E6] border border-[#D4A843] rounded p-1.5 text-center" data-id="element-104">
                          <p className="text-[#1F3D2B] font-black text-[10px] md:text-xs" data-id="element-105">
                            👉 {tomo.highlight}
                          </p>
                        </div>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <div className="text-center bg-[#1F3D2B] border-b-3 border-[#142a1d] rounded-xl p-2 shadow-lg" data-id="element-106">
          <p className="text-sm md:text-base font-black text-white mb-0.5 uppercase" data-id="element-107">
            🔥 Todo paso a paso, listo para aplicar.
          </p>
          <p className="text-xs font-black text-[#D4A843]" data-id="element-108">
            👉 Entrás a cada clase con todo resuelto.
          </p>
        </div>
      </div>
    </section>;
}